import { gql } from '@apollo/client';
import { resultContentBlock } from './result-content-block.gql';

export const pvWizardResultSection = gql`
  fragment PvWizardResultSection on PvWizardResultSection {
    __typename
    summary {
      ...ResultContentBlock
    }
  }

  ${resultContentBlock}
`;
